var React = require('react');

function Computer (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M14.635 0h56a3 3 0 0 1 3 3v29h-62V3a3 3 0 0 1 3-3zm5.2 5.333a2 2 0 0 0-2 2V26.71h49.6V7.333a2 2 0 0 0-2-2h-45.6zM.635 36h83a5 5 0 0 1-5 5h-73a5 5 0 0 1-5-5z","transform":"translate(-.635)"}));
}

Computer.defaultProps = {"viewBox":"0 0 83 41"};

module.exports = Computer;

Computer.default = Computer;
